// settings/workflow/helper/workflowConfigPayload.js

const deepClone = (obj) => {
  // structuredClone is best; fallback to JSON clone if needed
  if (typeof structuredClone === "function") return structuredClone(obj);
  return JSON.parse(JSON.stringify(obj));
};

export function buildWorkflowSavePayload(values) {
  const clone = deepClone(values);

  // Remove UI-only root fields if they exist
  delete clone.projectName;

  // Normalize steps
  clone.steps = (clone.steps || []).map((s, idx) => {
    const step = { ...s };

    // Sequence always equals list order
    step.sequence = idx + 1;

    // Exclusions requested by you (parent step fields)
    delete step.onReturnAction;
    delete step.onReturnGoToSequence;
    delete step.isOptional;
    delete step.requireCommentOnApprove;
    delete step.onRejectNotifyRoleId;
    delete step.onRejectNotifyRoleName;

    // UI-only
    delete step.roleName;

    // If reject action is not gotostep, clear goto sequence
    if (step.onRejectAction !== "gotostep") {
      step.onRejectGoToSequence = null;
    }

    // Normalize child steps
    step.childSteps = (step.childSteps || []).map((c, cIdx) => {
      const child = { ...c };
      child.sequence = cIdx + 1;

      // UI-only
      delete child.roleName;
      delete child.parentStepName;

      return child;
    });

    return step;
  });

  return clone;
}
